module.exports = __webpack_public_path__ + "media/images/static/top/urban/hero_jp_mobile-5236edd79fbbc15e940f88a709854c2e.png";